export default () => {
    return sessionStorage.removeItem('app_user')
}